module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Sad-df4665e11cc9bcd09bfe4506ca47f4b3.svg";